import React, { useState } from 'react'
import { Typography, Row, Col, Input } from 'antd'
import Button from 'components/shared/button'
import { useRouter } from 'next/router'
import { CurrencyIcon, roundToTwo, IswrongInput } from 'shared/util'

const { Title } = Typography

export default function PeRatioComponent() {
  const router = useRouter()
  const { currency = 'dollar' } = router.query
  const [assets, setassets] = useState('')
  const [liabilities, setliabilities] = useState('')
  const [result, setresult] = useState('')
  const [assetsColor, setassetsColor] = useState('#1890ff')
  const [liabilitiesColor, setliabilitiesColor] = useState('#1890ff')

  const handleCalculation = () => {
    if (IswrongInput(assets) || IswrongInput(liabilities)) {
      if (IswrongInput(assets)) {
        setassetsColor('#ff00008a')
      }
      if (IswrongInput(liabilities)) {
        setliabilitiesColor('#ff00008a')
      }
    } else {
      setresult(roundToTwo(assets / liabilities))
    }
  }

  const handleChange = (event) => {
    const inputValue = event.target.value
    if (event.target.id === 'assets') {
      setassets(inputValue)
      if (IswrongInput(inputValue)) {
        setassetsColor('#ff00008a')
      } else {
        setassetsColor('#1890ff')
      }
    } else {
      setliabilities(inputValue)
      if (IswrongInput(inputValue)) {
        setliabilitiesColor('#ff00008a')
      } else {
        setliabilitiesColor('#1890ff')
      }
    }
  }

  return (
    <div style={{ padding: '16px 8px 16px 8px' }}>
      <Title
        level={4}
        style={{
          height: '22px',
          fontWeight: '600',
          fontSize: '21px',
          lineHeight: '22px',
          alignItems: 'center',
          textAlign: 'center',
          color: '#000000',
        }}
      >
        PE Ratio Calculator
      </Title>
      <div>
        <Input
          id="assets"
          placeholder="Input Market Price per Share"
          onChange={handleChange}
          style={{ width: '256px' }}
          suffix={CurrencyIcon(currency, assetsColor)}
        />
      </div>
      <div>
        <Input
          id="liabilities"
          placeholder="Input Earnings Per Share"
          onChange={handleChange}
          style={{ width: '256px', marginTop: '16px' }}
          suffix={CurrencyIcon(currency, liabilitiesColor)}
        />
      </div>
      <Row style={{ display: 'flex', alignItems: 'center' }}>
        <Button
          size="large"
          type="primary"
          style={{ margin: '8px auto auto auto' }}
          onClick={handleCalculation}
        >
          Calculate
        </Button>
      </Row>
      <Title
        level={4}
        style={{
          fontSize: '14px',
          marginTop: '16px',
          textAlign: 'center',
        }}
      >
        PE Ratio
      </Title>
      <Input id="liabilities" value={result} style={{ width: '256px' }} />
      <Row>
        <Col span={24} style={{ color: '#595959', fontSize: '14px' }}>
          <Row
            span={24}
            style={{
              margin: '24px auto',
            }}
          >
            <Col
              span={9}
              style={{
                textAlign: 'center',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              PE Ratio
            </Col>
            <Col span={2} style={{ display: 'flex', alignItems: 'center' }}>
              =
            </Col>
            <Col span={11}>
              <div
                style={{
                  borderBottom: '1px solid',
                  whiteSpace: 'nowrap',
                }}
              >
                Market Price per Share
              </div>
              {'\n'}
              <div style={{ whiteSpace: 'nowrap' }}>Earnings Per Share</div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
